import { observable, decorate, action } from 'mobx'
import cognitoUser from '../cognito-objects/cognitoUser'

const initialState = {
  user: {
    email: '',
    verificationCode: '',
    newPassword: '',
    isSendingCode: false,
    isConfirming: false
  }
}

class ForgotPasswordStore {
  constructor (rootStore) {
    this.user = {
      ...initialState.user
    }
    this.rootStore = rootStore.stores
  }

  handleChange (value, name) {
    this.user[name] = value
  }

  resetState () {
    this.user = {
      ...initialState.user
    }
  }

  sendVerificatonCode (event) {
    event.preventDefault()
    this.user.isSendingCode = true
    const user = cognitoUser(this.user.email)
    const forgotPasswordObj = this
    user.forgotPassword({
      onSuccess: function (response) {
        forgotPasswordObj.rootStore.notificationStore.sendSuccessNotification('Pronto!', 'O código de verificação foi enviado para seu e-mail')
        forgotPasswordObj.user.isSendingCode = false
      },
      onFailure: function (error) {
        forgotPasswordObj.rootStore.notificationStore.sendErrorNotification('Erro!', 'Não foi possível enviar o código de confirmação')
        forgotPasswordObj.user.isSendingCode = false
      }
    })
  }

  confirmPassword (event) {
    event.preventDefault()
    this.user.isConfirming = true
    if (!this.user.email) {
      this.rootStore.notificationStore.sendErrorNotification('Erro!', 'Digite seu email')
      this.user.isConfirming = false
      return
    }
    const user = cognitoUser(this.user.email);
    const forgotPasswordObj = this
    user.confirmPassword(this.user.verificationCode, this.user.newPassword, {
      onSuccess: function (response) {
        forgotPasswordObj.rootStore.notificationStore.sendSuccessNotification('Pronto!', 'Sua senha foi alterada com sucesso')
        forgotPasswordObj.resetState()
        forgotPasswordObj.user.isConfirming = false
      },
      onFailure: function (error) {
        forgotPasswordObj.rootStore.notificationStore.sendErrorNotification('Erro!', 'Não foi possível alterar a senha')
        forgotPasswordObj.user.isConfirming = false
      }
    })
  }
}

decorate(ForgotPasswordStore, {
  user: observable,
  handleChange: action,
  confirmPassword: action,
  sendVerificatonCode: action,
})

export default ForgotPasswordStore



// WEBPACK FOOTER //
// ./src/stores/forgotPasswordStore.js